var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgPowerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 15.875H18.875C19.2305 15.875 19.5586 16.1211 19.668 16.4492C19.8047 16.8046 19.7227 17.1875 19.4492 17.4336L12.4492 23.5586C12.1211 23.8046 11.6836 23.832 11.3555 23.5859C11.0273 23.3671 10.8906 22.9296 11.0547 22.5468L13.1602 17.625H10.0977C9.74219 17.625 9.41407 17.4062 9.30469 17.0781C9.16797 16.7226 9.25001 16.3398 9.52344 16.0937L16.5234 9.96871C16.8516 9.72261 17.2891 9.69527 17.6172 9.94136C17.9453 10.1601 18.082 10.5976 17.918 10.9804L15.8125 15.875Z",
    fill: "#13C1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1523 8.77734C19.6719 8.77734 20.0547 9.26953 19.918 9.76172L18.4414 14.875H20.793C21.3125 14.875 21.75 15.3125 21.75 15.832C21.75 16.1328 21.6133 16.3789 21.3945 16.5703L14.3125 22.5859C14.1758 22.6953 14.0117 22.75 13.8203 22.75C13.3008 22.75 12.918 22.2578 13.0547 21.7656L14.5312 16.625H12.1523C11.6602 16.625 11.25 16.2148 11.25 15.7227C11.25 15.4492 11.3594 15.1758 11.5508 15.0117L18.6602 8.94141C18.7969 8.83203 18.9609 8.75 19.1523 8.75V8.77734ZM18.168 11.0742L13.2188 15.3125H15.4062C15.5977 15.3125 15.7891 15.4219 15.9258 15.5859C16.0352 15.75 16.0898 15.9688 16.0352 16.1602L14.8047 20.4531L19.8086 16.1875H17.5938C17.375 16.1875 17.1836 16.1055 17.0469 15.9414C16.9375 15.7773 16.8828 15.5586 16.9375 15.3672L18.168 11.0742Z",
    fill: "#36424E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPowerCircle);
export default __webpack_public_path__ + "static/media/img_powerCircle.ee326a395e0fff8f29c276a3dae12b9f.svg";
export { ForwardRef as ReactComponent };